import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

var supportedLanguages = ["en", "fr"]; // i18n languages
var langArray = [];
var cleanArray = [];
var lang = "en";
var myLang = "";

function getLanguages() {
  // if browser supports navigator.languages
  if (navigator.languages) {
    //get languages in order of preference from browser
    langArray = navigator.languages;
    // strip off extra characters from languages
    langArray.forEach(function(element) {
      cleanArray.push(element.substring(0, 2));
    });
    //check language array against list of supported languages and return once a match is found
    cleanArray.some(function(element) {
      if (
        element == supportedLanguages[0] ||
        element == supportedLanguages[1]
      ) {
        // if it does match, assign language
        lang = element;
        return lang;
      }
    });
  } else {
    // if browser doesn't support navigator.languages, get navigator.language
    myLang = navigator.language.substring(0, 2);
    //check if language matches a supported language
    if (myLang == supportedLanguages[0] || myLang == supportedLanguages[1]) {
      // if it does match, assign language
      lang = myLang;
      return lang;
    }
  }
}
getLanguages();

export const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: "en",
  messages: {
    en: {
      message: {
        beta: "beta",
        bizpal: "BizPaL",
        bizpal_logo_alt: "Open Services Logo",
        bizpal_title: "Open Services",
        close_btn: "Close",
        coming_soon: "Available Soon",
        copy_btn: "Copy to Clipboard",
        copy_success_text: "Your selection was copied to the clipboard.",
        copy_success_title: "Success!",
        copy_error_text: "Your selection was not copied to the clipboard.",
        copy_error_title: "Error!",
        dropdown_title: "About Us",
        home_link: "Home",
        feedback_link: "Send Feedback",
        fetch_error_text: "Something went wrong.",
        language_switcher: "Français",
        scroll_btn: "Back to Top",
        terms: "Terms and conditions",
        navigation_title: "On This Page",
        new: "New",
        on_roadmap: "On Roadmap",
        updated: "Updated"
      },
      status: {
        box_title: "Open Services technical status:",
        status_btn: "View Status Dashboard",
        text_api_error:
          "We are unable to retrieve the system status at the moment.",
        text_danger: "is not operational",
        text_err: "information is not available",
        text_loading: "Loading...",
        text_success: "is operational",
        text_warning: "is degraded"
      },
      faq: {
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad mini veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        title: "Frequently Asked Questions"
      },
      about: {
        title: "Open Services"
      },
      contact: {
        description:
          "Have a question about our tools, need help with implementation, or have a suggestion for future widgets? Our team is happy to answer all your questions.",
        description_2: "Email us at:",
        email: "Open Services Support",
        title: "Contact Us"
      },
      disclaimer: {
        title: "Terms and conditions"
      },
      browser_support: {
        browser_support_title: "Browser Support of Widgets",
        browser_support_text:
          "Our widgets are supported only in modern browsers. In order to best accomplish web development to the next level, some sacrifices had to be made in terms of support for Internet Explorer.",
        browser_support_no: "No",
        browser_support_yes: "Yes"
      },
      term_service: {
        term_please_read:
          "Before integrating our widgets into your web application, please read our Terms of Service:",
        term_service_title: "Terms of Service",
        term_service_paragraph: `Your access to and continued use of any web services on open.bizpal-perle.ca constitutes your acceptance of the following terms and conditions.
         If you do not agree with these terms and conditions, you should discontinue any use of the web services.`,
        term_service_text_1: `Information provided on open.bizpal-perle.ca is believed to be reliable when posted. However, Innovation, Science and Economic Development (ISED) Canada
         or any partners in it Partnership (<abbr title="Innovation, Science and Economic Development">ISED</abbr>/partners) does not guarantee the quality, accuracy, completeness
         or timeliness of the information provided. The information may change without notice and <abbr title="Innovation, Science and Economic Development">ISED</abbr>/partner
         assumes no obligation to update the information or advise on further developments or changes. Access to any web services on open.bizpal-perle.ca is provided on an
         “as is” basis. We may terminate or suspend access to our Services immediately, without prior notice or liability, for any reason whatsoever.`,
        term_service_text_2: `<abbr title="Innovation, Science and Economic Development">ISED</abbr>/partners disclaims all warranties, representations and conditions regarding
         the use of web services on open.bizpal-perle.ca or the information provided. <abbr title="Innovation, Science and Economic Development">ISED</abbr>/partners further disclaims
         any implied warranties or conditions of merchantability, fitness for a particular purpose or non-infringement of intellectual property rights.`,
        term_service_text_3: `<abbr title="Innovation, Science and Economic Development">ISED</abbr>/partners is not responsible for any direct, indirect, special, incidental or
         consequential damages arising in any manner out of the use of any web services on open.bizpal-perle.ca or reliance on the information contained on any web services on
         open.bizpal-perle.ca including damages for loss of use, lost business profits, business interruption and personal injury or any other financial loss of any kind.`,
        term_service_text_4: `<abbr title="Innovation, Science and Economic Development">ISED</abbr>/partners either owns the intellectual property rights, including copyright,
         or has acquired the necessary licences in the information, text, code and other media that together make up the contents of any web services on open.bizpal-perle.ca.
         You are granted a limited licence to display or print the information for your own personal use and for the purposes of using any web services on open.bizpal-perle.ca to
         enhance your business. You are solely and fully responsible for how you use the information on any web services on open.bizpal-perle.ca and the consequences resulting from
         that use.`,
        term_service_text_5: `Web services on open.bizpal-perle.ca may contain links to other sites and sources of information. These links are provided as references to help you
         identify and locate other resources that may help you develop your business. These other sites have been developed and are operated by entities other than
         <abbr title="Innovation, Science and Economic Development">ISED</abbr>/partners. <abbr title="Innovation, Science and Economic Development">ISED</abbr>/partners does not
         endorse these sites, nor is it responsible for the accuracy or appropriateness of the information contained on those sites.`,
        term_service_text_6: `These terms and conditions may change from time to time and it is your responsibility to check for updates. The last revision date for this version
         is December&nbsp;9,&nbsp;2022.`
      },
      widget_source: {
        widget_source_title: "Widget Source",
        widget_source_faq1: "Find more information in the widget ",
        widget_source_faq2: `<abbr title="Frequently Asked Questions">FAQ</abbr>`,
        widget_source_faq3: "."
      },
      logos: {
        alberta: "Alberta",
        british_columbia: "British Columbia",
        canada: "Canada",
        manitoba: "Manitoba",
        new_brunswick: "New Brunswick",
        newfoundland: "Newfoundland",
        northwest_territories: "Northwest Territories",
        nova_scotia: "Nova Scotia",
        ontario: "Ontario",
        open_service_governments:
          "Open Services is powered by BizPaL, in partnership with federal, provincial/territorial, municipal governments and First Nations.",
        prince_edward_island: "Prince Edward Island",
        quebec: "Quebec",
        saskatchewan: "Saskatchewan",
        yukon: "Yukon",
        bizpal: "BizPaL"
      },
      open_services: {
        description:
          "A collection of web services designed in the spirit of “build once, deploy everywhere”.  Save time and effort in new and existing digital products while benefiting from a larger data-based ecosystem. As a shared effort, domain experts continuously improve the Information Management (IM) underlying these services so that everyone benefits, and effort is not duplicated.",
        title: "What is Open Services?",
        data_api: {
          btn: "API Catalogue",
          path: "/api-catalogue",
          text:
            "Open APIs specifically connected with shared classification data. Leverage years of IM research and work within your organization's digital products. Pull in standardized data and add your own unique value for users.",
          title: "Data and APIs"
        },
        pub_tools: {
          btn: "IM Toolbox",
          path: "/publishing-tools",
          text:
            "Tools to help classify your content, services, and products using existing classification services. Our publishing tools leverage AI and Natural Language Processing to help categorize your offerings so that they fit into a larger ecosystem, and can be recommended in context through complimentary service via other participating organizations.",
          title: "Publishing Tools"
        },
        widgets: {
          btn: "Widget Catalogue",
          path: "/widgets",
          text:
            "Extend your digital product with tools that help match your information and services to your users' needs. Offer relevant, contextual information and insights to your users based on shared classification of resources.",
          title: "Widgets"
        }
      },
      widget_catalogue: {
        BBF_link: "Business Benefit Finder",
        BBF_subtitle: "",
        BBF_text:"Get a tailored list of programs and services for your business.",
        BET_link: "Business Structures Wizard",
        BET_subtitle: "",
        BET_text: `Help your user choose a business structure and learn the advantages of every one of them since each business structure has different and important implications for such things as liability and financing. This tool compares different business structure options and help determine which one may be the best fit for the business.`,
        naics_link: "Industry",
        naics_subtitle: "North American Industry Classification System (NAICS)",
        naics_text: `Help your user identify their industry using a convenient <b>type-ahead lookup</b> user interface. Uses an enhanced keywords effort based on vernacular used across Canada for preferred industry terms. For example, terms that a business might relate to, like “Hot dog stand” will correctly correlate to the <abbr title="North American Industry Classification System">NAICS</abbr> code for “Mobile Food Concession”. Includes automatic spelling tolerance in English and French. Returns a standard <abbr title="North American Industry Classification System">NAICS</abbr> code that can be used to relate contextual information and services.`,
        naics_tree_link: "Industry - Expanded (NAICS 2017 version)",
        naics2022_tree_link: "Industry - Expanded (NAICS 2022 version)",
        naics_tree_text: `Help your user identify their industry using a convenient <b>tree select</b> user interface. Uses an enhanced keywords effort based on vernacular used across Canada for preferred industry terms. For example, terms that a business might relate to, like “Restaurant” will provide potential matches within the hierarchy of <abbr title="North American Industry Classification System">NAICS</abbr> related to any sectors. Includes automatic spelling tolerance in English and French. Returns a standard <abbr title="North American Industry Classification System">NAICS</abbr> code that can be used to relate contextual information and services.`,
        noc_link: "Occupation",
        noc_subtitle: "National Occupational Classification (NOC)",
        noc_text:
          "Help your user identify their occupation using a convenient type-ahead user interface. Uses occupation keywords to help match to preferred terms, and includes automatic spelling tolerance in English and French and returns a standard NOC code that can be used to relate contextual information and services.",
        sgc_link: "Location",
        sgc_subtitle: "Standard Geographical Classification (SGC)",
        sgc_text: `Help your user identify their location using a convenient type-ahead lookup user interface. Uses neighbourhood keywords to help match to preferred terms. Includes automatic spelling tolerance in English and French. Returns a standard <abbr title="Standard Geographical Classification">SGC</abbr> code that can be used to relate contextual information and services.`,
        source: "Source: ",
        standard: "Standard: ",
        subtitle_1: "Self-identification Widgets",
        subtitle_2: "Business Insights Widgets",
        text_1:
          "Embeddable user interface components for your digital products. Help your users identify their industry or location using standard classification systems. Offer just-in-time, contextual information to your users based on shared classification used by other content providers.",
        text_2:
          "Common form widgets that help individuals and businesses personalize services.",
        text_3:
          "Data-driven widgets that provide personalized business insights based on criteria provided.",
        title: "Widgets",
        wage_link: "Wage",
        wage_subtitle:
          "2019 Wage Dataset, Employment and Social Development Canada",
        wage_text:
          "Help your user identify the common occupations and their average hourly wage associated with a particular industry, based on their specified location. Additionally, the user may compare two locations and/or industries. Employs enhanced keywords based on informal language used across Canada in order to match the appropriate industry and locations. Includes automatic spelling tolerance in English and French. Returns data in a table format, which may be exported as an Excel (XLS) file."
      },
      api_catalogue: {
        subtitle_1: "Subtitle One",
        subtitle_2: "Subtitle Two",
        text_1:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lacus sed viverra tellus in hac habitasse platea dictumst.",
        text_2:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        text_3:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        title: "Data and APIs"
      },
      publishing_tools: {
        subtitle_1: "Subtitle One",
        subtitle_2: "Subtitle Two",
        text_1:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lacus sed viverra tellus in hac habitasse platea dictumst.",
        text_2:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        text_3:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        title: "Publishing Tools"
      },
      widget_details: {
        additional_description:
          "The widget can be configured to meet the needs of your web product.",
        additional_instructions:
          "Expand for details of the various widget options",
        buefy_tag: "stylesheet link (optional)",
        ccs_style: "Widget Stylesheet Link",
        builder_link1:
          "The widget has many options that can be specified using ",
        builder_link2: "tag attributes",
        builder_link3:
          ". Use the customization tool below to configure the widget options.",
        custom_attributes: "Custom Tag Attributes",
        custom_attributes_docs: "Documentation for Custom Tag Attributes",
        customization_link: "Customization Tool",
        customize_tag: "// more customization options available",
        embed_title: "Customize the Widget",
        example_title: "Example:",
        fontawesome_tag: "import fontawesome icons (optional)",
        navigation_title: "On This Page",
        polyfill_tag: "Necessary Script Tags",
        replace_naics_id: "replace widgetID with your own id",
        code_comment: "code for integration with your app goes here",
        step_1:
          "1. Copy the necessary script tags and paste in the head section of the Web form/page.",
        step_2:
          "2. Copy the widget tag and paste into the part of the Web form/page where the widget should appear.",
        step_3:
          "3. Copy the script tag containing the source URL and paste at the BOTTOM of the body tag in Web form/page.",
        step_4:
          "4. The event 'change' is triggered when the selected value changes. It returns an object of an array of object(s) as follows:",
        step_5:
          "5. In order to display the return results on your page, you may use a script element to capture the results. Paste the following code at the bottom of your body element, just above the closing body tag.",
        step_4_value: "value",
        step_one: "Step 1: Head",
        step_two: "Step 2: Custom Tag",
        step_three: "Step 3: Tag Script",
        step_four: "Step 4: Return Results",
        step_five: "Step 5: Capturing the Results",
        title: "Widget Details",
        widget_tag: "Widget Tag",
        url_tag: "Widget Source URL Tag",
        usage_title: "Using the Widget",
        usage_subtitle:
          "Incorporating our widgets into your own web page or form only requires a few simple steps:",
        vue_tag: "Load Vue (not necessary for Vue applications)",
        faq: "Widget <abbr title='Frequently Asked Questions'>FAQ</abbr>"
      },
      form_fields: {
        show_results_label: "Display Results",
        callback_label: "Callback Function",
        component_options: "Widget Options",
        data_title: "Related Data:",
        display_label: "Display Label",
        example_title: "Live Example",
        example_tooltip:
          "The example below will update as you choose from the widget options to the right.",
        example_bbf_tooltip: `The example below will update as you choose from the widget options above.`,
        field_code_title: "Hidden Field Code",
        field_label: "Field Label",
        html_title: "HTML Code",
        html_tooltip:
          "The code below will update as you choose from the widget options to the right.",
        html_bbf_tooltip: `The code below will update as you choose from the widget options to the left.`,
        input_code_label: "Default Code",
        language_label: "Language",
        occupations_label: "Occupations",
        options_tooltip:
          "Use the form to customize the widget. The HTML code and live example will update with your selections.",
        placeholder_callback: "Add a callback function (Vue.js)",
        placeholder_field_label: "Customize the field label",
        placeholder_display_label: "Placeholder",
        placeholder_label: "Placeholder Text",
        placeholder_placeholder_text: "Customize the placeholder text",
        placeholder_input_code: "Include a default code",
        products_label: "Products",
        province_label: "Search Level",
        related_data: "Include Additional Data",
        reset: "Reset",
        results_title: "Live Example Results",
        results_tooltip:
          "The results of the lookup returns the selection in an object format with the associated code.",
        selection_label: "Selection Options",
        show_code_label: "Show Code",
        show_compare_label: "Compare Options",
        show_inputs_label: "Display Inputs",
        visibility_label: "Visibility",
        naics_code_label: "Default Industry",
        naics_level_label: "NAICS Level",
        sgc_code_label: "Default Location",
        naics_compare_label: "Industry for Comparison",
        sgc_compare_label: "Location for Comparison",
        table_label: "Table Label",
        button_label: "Button Label",
        placeholder_table_label: "Customize the table's label",
        placeholder_button_label: "Customize the button's label",
        placeholder_naics_code: "Enter a NAICS code",
        placeholder_sgc_code: "Enter a SGC code",
        tooltip_show_naics:
          "If 'hide' is selected, a default industry must be supplied, or the widget will not function.",
        tooltip_show_sgc:
          "If 'hide' is selected, a default location must be supplied, or the widget will not function.",
        tooltip_show_inputs:
          "If 'hide' is selected, a default industry and default location must be supplied, or the widget will not function.",
        tooltip_naics_code:
          "If you want the widget to load with a preselected industry as default, supply the industry's NAICS code.",
        tooltip_sgc_code:
          "If you want the widget to load with a preselected location as default, supply the location's SGC code.",
        tooltip_naics_compare_code:
          "If you want the widget to load with a preselected industry for comparison, supply the industry's NAICS code. The 'compare options' field above must be set to 'display compare checkbox.'",
        tooltip_sgc_compare_code:
          "If you want the widget to load with a preselected location for comparison, supply the location's SGC code. The 'compare options' field above must be set to 'display compare checkbox.'"
      },
      form_options: {
        placeholder_show_placeholder: "Customize the placeholder",
        placeholder_show_label: "Hide or display label",
        placeholder_lang: "Select a language",
        placeholder_multiple: "Multiple or single selections",
        placeholder_show_code: "Return code with name",
        placeholder_show_compare: "Hide or display compare checkbox",
        placeholder_show_inputs: "Hide or display input boxes",
        placeholder_province: "Search provinces or cities",
        placeholder_visibility: "Hide or display input box",
        placeholder_naics_level: "Select the NAICS level",
        placeholder_show_results: "Select results to show",
        resultsOptions: [
          { value: null, text: "Default - no results displayed" },
          { value: "1", text: "label [ code ]" },
          { value: "2", text: "label only" },
          { value: "3", text: "code only" }
        ],
        naicsLevelOptions: [
          { value: "2", text: "Default - 2 (2,3,4 and 6 digits)" },
          { value: "3", text: "3 (3,4 and 6 digits)" },
          { value: "4", text: "4 (4 and 6 digits)" },
          { value: "5", text: "5 (6 digits)" }
        ],
        placeholderOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Custom Placeholder Text" },
          { value: false, text: "No Placeholder Text" }
        ],
        labelOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Display Field Label" },
          { value: false, text: "Hide Field Label" }
        ],
        languageOptions: [
          { value: null, text: "Default" },
          { value: "en", text: "English" },
          { value: "fr", text: "French" }
        ],
        selectionOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Allow Multiple Selections" },
          { value: false, text: "Single Selection Only" }
        ],
        showCompareOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Display Compare Checkbox" },
          { value: false, text: "Hide Compare Checkbox" }
        ],
        showInputsOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Display Input Boxes" },
          { value: false, text: "Hide Input Boxes" }
        ],
        showOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Display Code Number" },
          { value: false, text: "Hide Code Number" }
        ],
        provinceOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Search Provinces" },
          { value: false, text: "Search Cities" }
        ],
        visibilityOptions: [
          { value: null, text: "Default" },
          { value: true, text: "Display Input Box" },
          { value: false, text: "Hide Input Box" }
        ],
        label_lang: "Language:",
        label_en: "English (en)",
        label_fr: "French (fr)",
        label_label: "Label:",
        placeholder_label: "Enter label for widget link",
        label_location: "Location:",
        placeholder_location: "Select province ID (example: 6,7)",
        provinceOptions: [
          { value: 0, text: "All of Canada (0)" },
          { value: 1, text: "Newfoundland and Labrador (1)" },
          { value: 2, text: "Prince Edward Island (2)" },
          { value: 3, text: "Nova Scotia (3)" },
          { value: 4, text: "New Brunswick (4)" },
          { value: 5, text: "Quebec (5)" },
          { value: 6, text: "Ontario (Northern region) (6)" },
          { value: 7, text: "Ontario (Southern/Eastern region) (7)" },
          { value: 8, text: "Manitoba (8)" },
          { value: 9, text: "Saskatchewan (9)" },
          { value: 10, text: "Alberta (10)" },
          { value: 11, text: "British Columbia (11)" },
          { value: 12, text: "Yukon (12)" },
          { value: 13, text: "Northwest Territories (13)" },
          { value: 14, text: "Nunavut (14)" }
        ],
        label_style: "Style option:",
        placeholder_style: "Enter style option number for widget link (default: 1)",
        note_style: `Note: For style option 4 (white link), just for the exemple a color background was added to be able to see link`,
        styleOptions: [
          { value: 1, text: "Default - blue button (1)" },
          { value: 2, text: "green button (2)" },
          { value: 3, text: "blue link (3)" },
          { value: 4, text: "white link (4)" }
        ]
      },
      not_found: {
        contact: "Contact us and we'll help you out.",
        home: "Return to the home page.",
        text: `We're sorry you ended up here. Sometimes a page gets moved or deleted. What next?`,
        title: "We couldn't find that Web page"
      }
    },
    fr: {
      message: {
        beta: "bêta",
        bizpal: "PerLE",
        bizpal_logo_alt: "Logo Services ouverts",
        bizpal_title: "Services ouverts",
        close_btn: "Fermer",
        copy_btn: "Copier dans le presse-papier",
        copy_success_text:
          "Votre sélection a été copiée dans le presse-papier.",
        copy_success_title: "Succès!",
        copy_error_text:
          "Votre sélection n'a pas été copiée dans le presse-papier.",
        copy_error_title: "Erreur!",
        dropdown_title: "À propos de nous",
        home_link: "Accueil",
        feedback_link: "Envoyez vos commentaires",
        fetch_error_text: "Quelque chose a mal fonctionné",
        language_switcher: "English",
        scroll_btn: "Haut de la page",
        terms: "Avis",
        coming_soon: "Bientôt disponible",
        new: "Nouveau",
        on_roadmap: "Plans futurs",
        updated: "Mis à jour"
      },
      status: {
        box_title: "L'état technique de Services ouverts&nbsp;:",
        status_btn: "Voir le tableau de bord sur l'état",
        text_api_error:
          "Nous sommes incapables de récupérer l'état du système pour le moment.",
        text_danger: "n'est pas opérationnel",
        text_err: "information n'est pas disponible",
        text_loading: "Chargement...",
        text_success: "est opérationnel",
        text_warning: "est dégradé"
      },
      faq: {
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad mini veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        title: "Foire aux questions"
      },
      about: {
        title: "Services ouverts"
      },
      contact: {
        description:
          "Vous avez des questions concernant nos outils, vous avez besoins d'aide avec l'implémentation ou vous avez une suggestion pour des widgets futures? Notre équipe se fera un plaisir de répondre à toutes vos questions.",
        description_2: "Envoyez-nous un courriel à :",
        email: "Soutien Services ouverts",
        title: "Contactez-nous"
      },
      disclaimer: {
        title: "Avis"
      },
      browser_support: {
        browser_support_title: "Soutien de navigation des Widgets",
        browser_support_text:
          "Nos widgets sont soutenus seulement dans des navigateurs modernes. Dans le but d'accomplir le meilleur développement web au niveau suivant, des sacrifices ont dû être effectué en termes de soutien d'Internet Explorer.",
        browser_support_no: "Non",
        browser_support_yes: "Oui"
      },
      term_service: {
        term_please_read:
          "Avant d'intégrer nos widgets dans votre application Web, veuillez lire nos conditions d'utilisation :",
        term_service_title: "Conditions d'utilisation",
        term_service_paragraph: `Le fait d'accéder aux services Web sur open.bizpal-perle.ca et de les utiliser de façon continue signifie que vous acceptez les modalités suivantes. 
         Si vous ne souscrivez pas à ces modalités, vous devez cesser toute utilisation des services Web.`,
        term_service_text_1: `Les renseignements fournis sur open.bizpal-perle.ca sont réputés être fiables lorsqu'ils sont affichés. Toutefois, Innovation, Sciences et 
         Développement économique (ISDE) Canada ou tout partenaire de ce partenariat (<abbr title="Innovation, Sciences et Développement économique">ISDE</abbr> et les partenaires)
         ne garantit pas la qualité, l'exactitude, l'exhaustivité ou l'actualité des renseignements fournis. Les renseignements peuvent être modifiés sans préavis et
         <abbr title="Innovation, Sciences et Développement économique">ISDE</abbr> et les partenaires n'assument aucune obligation de mettre à jour les renseignements ou d'indiquer
         d'autres changements. L'accès aux services Web sur open.bizpal-perle.ca est fourni tel quel. Nous pouvons mettre fin à votre accès à nos services ou le suspendre immédiatement,
         sans préavis ni dédommagement, pour quelque raison que ce soit.`,
        term_service_text_2: `<abbr title="Innovation, Sciences et Développement économique">ISDE</abbr> et les partenaires se désistent de toute responsabilité quant aux garanties,
         aux représentations et aux conditions concernant l'utilisation des services Web sur open.bizpal-perle.ca ou les renseignements fournis. Ils se désistent également de toute
         responsabilité quant aux garanties ou aux conditions implicites concernant la valeur commerciale, l'adaptation à un usage particulier ou la non-violation des droits de
         propriété intellectuelle.`,
        term_service_text_3: `<abbr title="Innovation, Sciences et Développement économique">ISDE</abbr> et les partenaires ne sont pas responsables des dommages directs, indirects,
         spéciaux, accessoires ou consécutifs découlant de quelconque manière de l'utilisation des services Web sur open.bizpal-perle.ca ou de la confiance envers les renseignements
         contenus dans les services Web sur open.bizpal-perle.ca, y compris les dommages pour perte d'utilisation, les profits d'entreprise perdus, l'interruption des activités et
         les blessures corporelles ou toute autre perte financière, quelle qu'elle soit.`,
        term_service_text_4: `<abbr title="Innovation, Sciences et Développement économique">ISDE</abbr> et les partenaires possèdent les droits de propriété intellectuelle, y compris
         les droits d'auteur, ou ont acquis les licences nécessaires en ce qui a trait aux renseignements, aux textes, aux codes et aux autres médias qui, ensemble, constituent
         le contenu des services Web sur open.bizpal-perle.ca. Vous avez droit à une licence limitée pour afficher ou imprimer les renseignements en vue d'une utilisation personnelle
         et dans le but d'utiliser les services Web sur open.bizpal-perle.ca pour développer votre entreprise. Vous assumez l'unique et l'entière responsabilité de la façon dont vous
         utilisez les renseignements des services Web sur open.bizpal-perle.ca et des conséquences qui en découlent.`,
        term_service_text_5: `Les services Web sur open.bizpal-perle.ca peuvent contenir des liens vers d'autres sites et d'autres sources d'information. Ces liens sont fournis à titre
         de référence afin de vous permettre de trouver d'autres sources qui pourraient vous aider à développer votre entreprise. Ces autres sites ont été élaborés et sont exploités
         par des entités autre qu'<abbr title="Innovation, Sciences et Développement économique">ISDE</abbr> et les partenaires, c'est pourquoi
         <abbr title="Innovation, Sciences et Développement économique">ISDE</abbr> et les partenaires ne sont pas responsables de ces sites ni de l'exactitude ou de la pertinence
         des renseignements qu'ils contiennent.`,
        term_service_text_6: `Ces modalités peuvent changer de temps à autre et il est de votre responsabilité de vérifier les mises à jour. La date de la dernière révision de
         cette version est le 9&nbsp;décembre&nbsp;2022.`
      },
      widget_source: {
        widget_source_title: "Source du widget",
        widget_source_faq1: " Obtenez plus de renseignement dans la ",
        widget_source_faq2: `<abbr title="Foire aux questions">FAQ</abbr>`,
        widget_source_faq3: " du widget."
      },
      logos: {
        alberta: "Alberta",
        british_columbia: "Colombie-Britannique",
        canada: "Canada",
        manitoba: "Manitoba",
        new_brunswick: "Nouveau-Brunswick",
        newfoundland: "Terre-Neuve-et-Labrador",
        northwest_territories: "Territoires de Nord-Ouest",
        nova_scotia: "Nouvelle-Écosse",
        ontario: "Ontario",
        open_service_governments:
          "Services ouverts est fourni par PerLE, en partenariat avec les gouvernements fédéral, provinciaux et territoriaux, les administrations municipales et les premières nations.",
        prince_edward_island: "Île-du-Prince-Édouard",
        quebec: "Québec",
        saskatchewan: "Saskatchewan",
        yukon: "Yukon",
        bizpal: "PerLE"
      },
      open_services: {
        description:
          "Une collection de services Web conçu dans l'idée de «&nbsp;construire une fois, déployer partout&nbsp;». Sauver du temps et d'effort dans de nouveaux et existant produits numériques en bénéficiant d'un écosystème basé sur des données plus vastes. Faisant parti d'un effort partagé, les experts du domaine améliorent continuellement la Gestion de l'information (GI) sous-tendant ses services pour que tout le monde en bénéficie et ainsi éviter le chevauchement des efforts.",
        title: "Qu'est-ce que Services ouverts?",
        data_api: {
          btn: "Catalogue d'API",
          path: "/catalogue-api",
          text: `API ouvert connecté spécifiquement avec les données de classification partagés. Miser sur des années de recherche et de travail GI relevant des produits numériques de votre organisation. Rechercher des données normalisées et ajouter votre propre valeur unique pour les utilisateurs.`,
          title: "Données et API"
        },
        widgets: {
          btn: "Catalogue de widgets",
          path: "/widgets",
          text:
            "Élargissez votre produit numérique avec des outils qui aident à apparier vos informations et vos services aux besoins de vos utilisateurs. Offrez de l'information pertinent et contextuel à vos utilisateurs basé sur des ressources de classification partagés.",
          title: "Widgets"
        },
        pub_tools: {
          btn: "Boîte à outils GI",
          path: "/outils-publication",
          text:
            "Outils pour vous aider à classer votre contenu, vos services et produits en utilisant les services de classification existant. Nos outils de publication mise sur le processus de langage d'IA et naturel pour aider à catégoriser vos offres à ce qu'ils s'intègrent dans un plus vaste écosystème et peut être recommandé dans le contexte de services complémentaires via d'autres organisations participantes.",
          title: "Outils de publication"
        }
      },
      api_catalogue: {
        subtitle_1: "Sous-titre un",
        subtitle_2: "sous-titre deux",
        text_1:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lacus sed viverra tellus in hac habitasse platea dictumst.",
        text_2:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        text_3:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        title: "Données et API"
      },
      publishing_tools: {
        subtitle_1: "Sous-titre un",
        subtitle_2: "sous-titre deux",
        text_1:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lacus sed viverra tellus in hac habitasse platea dictumst.",
        text_2:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        text_3:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ut porttitor leo a diam sollicitudin. Aliquam ut porttitor leo a diam sollicitudin.",
        title: "Outils de publication"
      },
      widget_catalogue: {
        BBF_link: "Outil de recherche d'aide aux entreprises",
        BBF_subtitle: "",
        BBF_text:"Obtenez une liste personnalisée de programmes et services pour votre entreprise.",
        BET_link: "Assistant de structures d'entreprise",
        BET_subtitle: "",
        BET_text: `Aide l'utilisateur à choisir une structure d'entreprise et à connaître les avantages de chacune parce que chaque structure d'entreprise a des répercussions différentes et considérables sur des aspects tels que la responsabilité et le financement. Cet outil compare différentes options de structure d'entreprise et détermine celle qui conviendrait le mieux à l'entreprise.`,
        naics_link: "Industrie",
        naics_subtitle:
          "Système de classification des industries de l'Amérique du Nord (SCIAN)",
        naics_text: `Aide l'utilisateur à identifier leur industrie en utilisant l'interface d'utilisateur pratique de <b>recherche avec autocomplétion</b>. Utilise des mots-clés rehaussés par des efforts basés sur le langage quotidien utilisé à travers du Canada pour les termes d'industrie préférentiels. Par exemple, les termes qu'une entreprise peut se rapporter à, comme «&nbsp;stand de hot-dogs&nbsp;» va corréler correctement au code <abbr title="Système de classification des industries de l'Amérique du Nord">SCIAN</abbr> pour «&nbsp;Concessions, stands ou camions alimentaires mobiles&nbsp;». Inclus une tolérance d'orthographe automatique en anglais et français. Retourne un code <abbr title="Système de classification des industries de l'Amérique du Nord">SCIAN</abbr> standard qui peut être utiliser à lier l'information et les services contextuelles.`,
        naics_tree_link: "Industrie - Étendu (version SCIAN 2017)",
        naics2022_tree_link: "Industrie - Étendu (version SCIAN 2022)",
        naics_tree_text: `Aide l'utilisateur à identifier leur industrie en utilisant l'interface d'utilisateur pratique de <b>sélection arborescence</b>. Utilise des mots-clés rehaussés par des efforts basés sur le langage quotidien utilisé à travers du Canada pour les termes d'industrie préférentiels. Par exemple, les termes qu'une entreprise peut se rapporter à, comme «&nbsp;restaurant&nbsp;» fournira toutes les correspondances potentielles dans la hiérarchie du <abbr title="Système de classification des industries de l'Amérique du Nord">SCIAN</abbr> sous n'importe quel secteur. Inclus une tolérance d'orthographe automatique en anglais et français. Retourne un code SCIAN standard qui peut être utiliser à lier l'information et les services contextuelles.`,
        noc_link: "Profession",
        noc_subtitle:
          "Système de classification nationale des professions (CNP)",
        noc_text:
          "Aide l'utilisateur à identifier leur profession en utilisant l'interface d'utilisateur pratique de d'autocomplétion. Utilise des mots-clés de professions pour aider à apparier aux termes préférentiels. Inclus une tolérance d'orthographe automatique en anglais et français. Retourne un code CNP standard qui peut être utiliser à lier l'information et les services contextuelles.",
        sgc_link: "Emplacement",
        sgc_subtitle: "Classification géographique type (CGT)",
        sgc_text: `Aide l'utilisateur à identifier leur emplacement en utilisant l'interface d'utilisateur pratique de recherche avec autocomplétion. Utilise des mots-clés des environs pour aider à apparier aux termes préférentiels. Inclus une tolérance d'orthographe automatique en anglais et français. Retourne un code <abbr title="Classification géographique type">CGT</abbr> standard qui peut être utiliser à lier l'information et les services contextuelles.`,
        source: "Source : ",
        standard: "Type : ",
        subtitle_1: "Widgets d'auto-identification",
        subtitle_2: "Widgets d'aperçu du marché",
        text_1:
          "Composants d'interface utilisateur intégrables pour vos produits numériques. Aidez vos utilisateurs à identifier leur industrie ou leur emplacement en utilisant des normes de classification. Offrez des informations contextuelle et juste à temps à vos utilisateurs en fonction de classification partagée utilisée par d'autres fournisseurs de contenu.",
        text_2:
          "Forme commune de widgets qui aide les individus et entreprises à personnaliser leur service.",
        text_3:
          "Widgets axés sur les données qui fournissent un aperçu du marché personnalisé basé sur des critères fournis.",
        title: "Widgets",
        wage_link: "Salaire",
        wage_subtitle:
          "Jeu de données des salaires 2019, Emploi et Développement social Canada",
        wage_text:
          "Aidez votre utilisateur à identifier le salaire horaire médian pour les professions associées à son industrie particulier, en fonction de son emplacement spécifié. De plus, l'utilisateur peut comparer deux emplacements et/ou industries. Le widget utilise des mots clés améliorés basés sur un langage informel utilisé partout au Canada afin de les faire correspondre aux industries et aux emplacements appropriés. Il comprend la tolérance d'orthographe automatique en anglais et en français. Le widget renvoie des données sous forme de tableau, qui peuvent être exportées sous forme de fichier Excel (XLS)."
      },
      widget_details: {
        additional_description:
          "Le widget peut être configuré pour répondre aux besoins de votre produit Web.",
        additional_instructions:
          "Cliquez pour les détails sur les différentes options du widget",
        builder_link1:
          "Le widget a plusieurs options qui peuvent être spécifiés en utilisant des ",
        builder_link2: "étiquettes d'attributs",
        builder_link3:
          ". Utiliser l'outil de personnlisation ci-dessous pour configurer les options du widget.",
        buefy_tag: "lien pour feuilles de style (optionnel)",
        ccs_style: "Lien pour feuilles de style du widget",
        custom_attributes: "Étiquettes d'attributs personnalisables",
        custom_attributes_docs:
          "Documentation pour les étiquettes d'attributs personnalisables",
        customization_link: "Outil de personnalisation",
        customize_tag: "// d'autres options personnalisables disponible",
        embed_title: "Personnaliser le widget",
        example_title: "Exemple&nbsp;:",
        fontawesome_tag: "importer les icônes Fontawesome (optionnel)",
        navigation_title: "Sur cette page",
        polyfill_tag: "Balises script nécessaires",
        replace_naics_id: "remplacez widgetID avec votre propre ID",
        code_comment:
          "insérez ici le code pour votre intégration avec votre application ou site Web",
        step_1:
          "1. Copiez les balises script nécessaires et collez dans la section en-tête du formulaire Web ou page.",
        step_2:
          "2. Copiez la balise du widget et collez dans la partie du formulaire Web ou page où le widget devrait s'afficher.",
        step_3:
          "3. Copiez la balise script avec la source de l'URL et collez au BAS de la balise BODY du formulaire Web ou page.",
        step_4:
          "4. L'événement «&nbsp;change&nbsp;» (changement) est déclenché lorsque la valeur sélectionnée change. Il retourne un objet de tableau («&nbsp;array&nbsp;») d'objet(s) comme suit&nbsp;:",
        step_4_value: "valeur",
        step_5:
          "Dans le but d'afficher les résultats retournés sur votre page, vous pouvez utiliser une balise script pour saisir les résultats. Collez le code suivant au bas de la balise BODY juste avant sa fermeture.",
        step_one: "Étape 1 : En-tête",
        step_two: "Étape 2 : Balise personnalisée",
        step_three: "Étape 3 : Balise script",
        step_four: " Étape 4 : Résultats retournés",
        step_five: "Étape 5 : Saisir les résultats",
        title: "Détails du widgets",
        usage_title: "Utilisation du widget",
        usage_subtitle:
          "L'incorporation de nos widgets dans votre propre page Web ou formulaire exige seulement quelques étapes&nbsp;:",
        widget_tag: "Balise du widget",
        url_tag: "Balise script avec la source de l'URL du widget",
        vue_tag:
          "Charger la librairie Vue.js (pas nécessaire pour les applications Vue)",
        faq: "<abbr title='Foire aux questions'>FAQ</abbr> du widget"
      },
      form_fields: {
        show_results_label: "Afficher résultats",
        callback_label: "Fonction de rappel",
        component_options: "Options du widget",
        data_title: "Données connexes&nbsp;:",
        display_label: "Afficher l'étiquette",
        example_title: "Exemple en direct",
        example_tooltip:
          "Utilisez les options du widget à droite pour modifier l'exemple en direct ci-dessous.",
        example_bbf_tooltip: `Utilisez les options du widget en haut pour modifier l'exemple en direct ci-dessous.`,
        field_code_title: "Code de champ caché",
        field_label: "Étiquette du champ",
        html_title: "Code HTML",
        html_tooltip:
          "Le code ci-dessous va se mettre à jour lorsque vous choisissez des options du widget à droite.",
        html_bbf_tooltip: `Le code ci-dessous va se mettre à jour lorsque vous choisissez des options du widget à gauche.`,
        input_code_label: "Code par défaut",
        language_label: "Langue",
        occupations_label: "Professions",
        options_tooltip:
          "Utilisez le formulaire pour personnaliser le widget. Le code HTML et l'exemple en direct vont se mettre à jour avec vos sélections.",
        placeholder_callback: "Ajouter une fonction de rappel (Vue.js)",
        placeholder_field_label: "Personnaliser l'étiquette de champ",
        placeholder_display_label: "Espace réservé",
        placeholder_label: "Espace de texte réservé",
        placeholder_placeholder_text: "Personnaliser l'espace de texte réservé",
        placeholder_input_code: "Inclure un code par défaut",
        placeholder_show_code:
          "Retourner le numéro de code avec le nom du résultat",
        products_label: "Produits",
        province_label: "Niveau de la recherche",
        related_data: "Inclure les données supplémentaires",
        reset: "Réinitialiser",
        results_title: "Résultats de l'exemple en direct",
        results_tooltip:
          "Les résultats de la recherche retournent la selection en format objet avec le code associé.",
        selection_label: "Options de sélection",
        show_code_label: "Afficher le code",
        show_compare_label: "Options de comparaison",
        show_inputs_label: "Afficher les boîtes d'entrées",
        visibility_label: "Visibilité",
        naics_code_label: "Industrie par défaut",
        naics_level_label: "Niveau du SCIAN",
        sgc_code_label: "Emplacement par défaut",
        naics_compare_label: "Industrie pour comparaison",
        sgc_compare_label: "Emplacement pour comparaison",
        table_label: "Étiquette du tableau",
        button_label: "Étiquette du bouton",
        placeholder_table_label: "Personnaliser l'étiquette du tableau",
        placeholder_button_label: "Personnaliser l'étiquette du bouton",
        placeholder_naics_code: "Entrer un code SCIAN",
        placeholder_sgc_code: "Enter un code CGT",
        tooltip_show_naics:
          "Si 'masquer' est sélectionné, une industrie par défaut doivent être fourni sinon le widget ne fonctionnera pas.",
        tooltip_show_sgc:
          "Si 'masquer' est sélectionné, un emplacement par défaut doivent être fourni sinon le widget ne fonctionnera pas.",
        tooltip_show_inputs:
          "Si 'masquer' est sélectionné, une industrie et l'emplacement par défaut doivent être fourni sinon le widget ne fonctionnera pas.",
        tooltip_naics_code:
          "Si vous voulez que le widget soit charger avec une industrie présélectionné comme défaut, fournissez le code SCIAN de l'industrie.",
        tooltip_sgc_code:
          "Si vous voulez que le widget soit charger avec un emplacement présélectionné comme défaut, fournissez le code CGT de l'emplacement.",
        tooltip_naics_compare_code:
          "Si vous voulez que le widget soit charger avec une industrie présélectionné pour comparaison, fournissez le code SCIAN de l'industrie. Le champ 'options de comparaison' ci-dessus doit être mis à 'afficher la boîte de comparaison'.",
        tooltip_sgc_compare_code:
          "Si vous voulez que le widget soit charger avec un emplacement présélectionné pour comparaison, fournissez le code CGT de l'emplacement. Le champ 'options de comparaison' ci-dessus doit être mis à 'afficher la boîte de comparaison'."
      },
      form_options: {
        placeholder_show_placeholder: "Personnaliser l'espace réservé",
        placeholder_show_label: "Masquer ou afficher l'étiquette",
        placeholder_lang: "Sélectionner une langue",
        placeholder_multiple: "Sélection multiple ou une seule",
        placeholder_show_code: "Retourner le code avec le nom",
        placeholder_show_compare: "Afficher ou masquer la case de comparaison",
        placeholder_show_inputs: "Afficher ou masquer les boîtes d'entrées",
        placeholder_province: "Rechercher par province ou par ville",
        placeholder_visibility: "Masquer ou afficher la boîte d'entrée",
        placeholder_naics_level: "Sélectionner le niveau du SCIAN",
        placeholder_show_results: "Sélectionner les résultats à afficher",
        resultsOptions: [
          { value: "", text: "Défaut - aucun résultat afficher" },
          { value: "1", text: "étiquette [ code ]" },
          { value: "2", text: "étiquett seulement" },
          { value: "3", text: "code seulement" }
        ],
        naicsLevelOptions: [
          { value: "2", text: "Défaut - 2 (2,3,4 et 6 chiffres)" },
          { value: "3", text: "3 (3,4 et 6 chiffres)" },
          { value: "4", text: "4 (4 et 6 chiffres)" },
          { value: "5", text: "5 (6 chiffres)" }
        ],
        placeholderOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Espace de texte personnalisé réservé" },
          { value: false, text: "Aucun espace de texte réservé" }
        ],
        labelOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Afficher l'étiquette du champ" },
          { value: false, text: "Masquer l'étiquette du champ" }
        ],
        languageOptions: [
          { value: null, text: "Défaut" },
          { value: "en", text: "Anglais" },
          { value: "fr", text: "Français" }
        ],
        selectionOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Permettre une sélection multiple" },
          { value: false, text: "Seulement une seule sélection" }
        ],
        showCompareOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Afficher la case de comparaison" },
          { value: false, text: "Masquer la case de comparaison" }
        ],
        showInputsOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Afficher les boîtes d'entrées" },
          { value: false, text: "Masquer les boîtes d'entrées" }
        ],
        showOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Afficher le numéro de code" },
          { value: false, text: "Masquer le numéro de code" }
        ],
        provinceOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Rechercher par province" },
          { value: false, text: "Rechercher par ville" }
        ],
        visibilityOptions: [
          { value: null, text: "Défaut" },
          { value: true, text: "Afficher la boîte d'entrée" },
          { value: false, text: "Masquer la boîte d'entrée" }
        ],
        label_lang: "Langage :",
        label_en: "Anglais (en)",
        label_fr: "Français (fr)",
        label_label: "Étiquette :",
        placeholder_label: "Entrez une étiquette pour lien du widget",
        label_location: "Emplacement :",
        placeholder_location: "Entrez l'ID de province (exemple : 6,7)",
        provinceOptions: [
          { value: 0, text: "tout le Canada (0)" },
          { value: 1, text: "Terre-Neuve-et-Labrador (1)" },
          { value: 2, text: "Île-du-Prince-Édouard (2)" },
          { value: 3, text: "Nouvelle-Écosse (3)" },
          { value: 4, text: "Nouveau-Brunswick (4)" },
          { value: 5, text: "Québec (5)" },
          { value: 6, text: "Ontario (Région du Nord) (6)" },
          { value: 7, text: "Ontario (Région du Sud/Région de l'Est) (7)" },
          { value: 8, text: "Manitoba (8)" },
          { value: 9, text: "Saskatchewan (9)" },
          { value: 10, text: "Alberta (10)" },
          { value: 11, text: "Colombie-Britannique (11)" },
          { value: 12, text: "Yukon (12)" },
          { value: 13, text: "Territoires du Nord-Ouest (13)" },
          { value: 14, text: "Nunavut (14)" }
        ],
        label_style: "Option du style :",
        placeholder_style: "Entrez nombre pour option du style pour lien du widget (défaut : 1)",
        styleOptions: [
          { value: 1, text: "Défaut - bouton bleu (1)" },
          { value: 2, text: "bouton vert (2)" },
          { value: 3, text: "lien bleu (3)" },
          { value: 4, text: "lien blanc (4)" }
        ],
        note_style: `Note : Pour option du style 4 (lien blanc), juste pour l'exemple une couleur a été ajouté en arrière-plan pour voir le lien`
      },
      not_found: {
        contact: "Communiquez avec nous pour obtenir de l'aide",
        home: "Retournez à la page d'accueil",
        title: "Nous ne pouvons trouver cette page Web",
        text:
          "Nous sommes désolés que vous ayez abouti ici. Il arrive parfois qu'une page ait été déplacée ou supprimée. Que faire?"
      }
    }
  }
});
